var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _path5, _linearGradient3, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 0.994,
    x2: 36,
    y2: 99.001,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efc402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#f1c829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#f4d264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#f7dc8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#f9e5ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#fbecc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#fcf3dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#fef9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#fffdf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fillOpacity: 0,
    stroke: "#ba9c02",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 92.1v-3.6l10.5-12.9h-9.3v-3.4h14.7v3.1l-11 13.4h11.4V92H14.4zm18.7 0V72.2h4V92h-4zm7.9 0V72.2h6.5c2.5 0 4.1.1 4.8.3 1.1.3 2.1.9 2.9 1.9s1.2 2.3 1.2 3.9c0 1.2-.2 2.2-.7 3.1s-1 1.5-1.7 2-1.4.8-2.1.9c-1 .2-2.4.3-4.2.3h-2.6v7.5H41zm4.1-16.5v5.6h2.2c1.6 0 2.7-.1 3.2-.3s1-.5 1.3-1 .5-1 .5-1.5c0-.7-.2-1.3-.6-1.8-.4-.5-1-.8-1.6-.9-.5-.1-1.5-.1-2.9-.1h-2.1z",
    fill: "#a07802"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 45.068,
    y1: 72.204,
    x2: 58.568,
    y2: 85.704,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#fffefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#fefaf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#fdf5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#fcf0d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#fae9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#f9e2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#f7da83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#f4d15d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#f1c827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efc402"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fillOpacity: 0,
    stroke: "#ba9c02",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 33.6,
    y1: 38.712,
    x2: 33.6,
    y2: 96.031,
    gradientTransform: "matrix(1 0 0 -1 0 100)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#a47d03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#debe00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#cfad04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a07802"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 15.8h-8.5v-4.9H38v4.9zm0 9h-8.5v4.9H38v-4.9zM38 4h-8.5v4.9H38V4zm0 13.8h-8.5v4.9H38v-4.9zm0 13.9h-8.5v4.9H38v-4.9zm.7 24.5c0 2.8-2.3 5-5.1 5s-5.1-2.3-5.1-5v-.5l1.7-14.6c0-1.9 1.5-3.4 3.4-3.4 1.8 0 3.3 1.5 3.4 3.3l1.6 14.4c.1.3.1.5.1.8zm-1.6-.2c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5c2 0 3.5-1.6 3.5-3.5z",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 41.6l-2.3-4.5v-2.3l2.3-2.2h2.2l2.3 2.2v2.3l-2.3 4.5h-2.2z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.73519fe5286044dbb415d485ef6bbc53.svg";
export { ForwardRef as ReactComponent };